import { register } from '../component.js';
import 'react';

var _socialIcons_x = register("x", {"color":"#000000","path":"M0 0v64h64V0zm16 17.537h10.125l6.992 9.242 8.084-9.242h4.908L35.39 29.79 48 46.463h-9.875l-7.734-10.111-8.85 10.11h-4.908l11.465-13.105zm5.73 2.783 17.75 23.205h2.72L24.647 20.32z"});

export { _socialIcons_x as default };
